export const L10N = {
  ACTION_RESERVE: { id: 'common.action.reserve', defaultMessage: '　　　' },
};
